// @flow
import packageJson from '../../package.json';

// Featureflow client-side SDK keys, one per deployment environment. Staging and
// production share the same production build, so the key is chosen at runtime
// from the hostname (see resolveFfApiKey). An explicit REACT_APP_FF_API_KEY env
// var always wins if set.
const FF_API_KEYS = {
  production: 'sdk-js-env-6fed4dee32af4989b8e235156a7fa187',
  staging: 'sdk-js-env-540cf20b63c8438080191e260de3e706',
  development: 'sdk-js-env-d543fdbd82624528978e7aedd16a8f36',
};

function resolveFfApiKey(): string {
  if (process.env.REACT_APP_FF_API_KEY) {
    return process.env.REACT_APP_FF_API_KEY;
  }
  const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
  // Staging domains must be checked before production.
  if (hostname.endsWith('featureflow-staging.com') || hostname.endsWith('featureflow-test.com')) {
    return FF_API_KEYS.staging;
  }
  if (hostname.endsWith('featureflow.com') || hostname.endsWith('featureflow.io')) {
    return FF_API_KEYS.production;
  }
  return FF_API_KEYS.development;
}

const CONSTANTS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  VERSION: packageJson.version,
  FF_API_KEY: resolveFfApiKey(),
}
export default CONSTANTS;
